import { useState } from "react";
import styled from "styled-components";
import LandingButton from "../../../LandingButton/LandingButton";
import {
  BottomSheetBase,
  BSCloseBtn,
  BSFooter,
  BSHeader,
  BSTitle,
  CloseSvg,
} from "./BottomSheetBase";
import type { BottomSheetData, FilterListItem } from "./FilterSort.types";

interface SortBottomSheetProps {
  data: BottomSheetData;
  defaultValue?: string;
  activeFilterQuoteIds?: Set<string> | null;
  onApply: (sortKey: string, quoteIds: string[]) => void;
  onClose: () => void;
}

export const SortBottomSheet = ({
  data,
  defaultValue,
  activeFilterQuoteIds,
  onApply,
  onClose,
}: SortBottomSheetProps) => {
  const list = data.list as FilterListItem[];
  const [selected, setSelected] = useState<string>(
    defaultValue || list[0]?.key || ""
  );

  const handleApply = () => {
    const item = list.find((i) => i.key === selected);
    if (item) {
      const sortIds = item.quoteIds || [];
      if (activeFilterQuoteIds && activeFilterQuoteIds.size > 0) {
        const filtered = sortIds.filter((id) => activeFilterQuoteIds.has(id));
        onApply(item.key, filtered);
      } else {
        onApply(item.key, sortIds);
      }
    }
  };

  return (
    <BottomSheetBase onClose={onClose}>
      <BSHeader>
        <BSCloseBtn type="button" onClick={onClose} aria-label="Close">
          <CloseSvg />
        </BSCloseBtn>
        <BSTitle>{data.heading || "Sort By"}</BSTitle>
      </BSHeader>

      <Body>
        {list.map((item) => (
          <RadioRow
            key={item.key}
            type="button"
            onClick={() => setSelected(item.key)}
          >
            <RadioOuter $on={selected === item.key}>
              {selected === item.key ? <RadioInner /> : null}
            </RadioOuter>
            <RadioLabel $on={selected === item.key}>{item.label}</RadioLabel>
          </RadioRow>
        ))}
      </Body>

      {data.cta?.right ? (
        <BSFooter>
          <LandingButton
            customTitle={data.cta.right}
            customWidth="100%"
            customHeight="44px"
            onClick={handleApply}
            flex="1"
            shadowVariant="none"
          />
        </BSFooter>
      ) : null}
    </BottomSheetBase>
  );
};

const Body = styled.div`
  padding: 8px 16px 16px;
`;

const RadioRow = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 14px 0;
  border: none;
  background: none;
  cursor: pointer;
  text-align: left;
  font: inherit;
`;

const RadioOuter = styled.span<{ $on: boolean }>`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid ${(p) => (p.$on ? "#008cff" : "#d8d8d8")};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const RadioInner = styled.span`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #008cff;
`;

const RadioLabel = styled.span<{ $on: boolean }>`
  font-size: 16px;
  font-weight: ${(p) => (p.$on ? 700 : 400)};
  color: #4a4a4a;
`;
